import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
    standalone: false,
    selector: "app-right-aside-nav-nested",
    templateUrl: "./right-aside-nav-nested.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class RightAsideNavNestedComponent implements OnInit, AfterViewInit {

    visible: boolean;
    rows: any[] = [];

    constructor() {
        localStorage.removeItem('rightAside-nested');
    }
    ngOnInit() {
        this.checkRightAside();
    }

    checkRightAside() {
        if (localStorage.getItem('rightAside-nested')) {
            $('[data-toggle="m-tooltip"]').tooltip('dispose');
            let rightAside = JSON.parse(localStorage.getItem('rightAside-nested'));
            if (rightAside) {
                this.visible = rightAside.visible;
                this.rows = rightAside.rows;
            }
            else this.visible = false;
        }
        else {
            setTimeout(() => {
                this.checkRightAside();
            }, 1000);
        }
    }

    ngAfterViewInit() {
        $('[data-toggle="m-tooltip"]').tooltip();
    }

}
